import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'
import { API_BASE } from '@/config/apiBase'

const request = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  // 跨域时携带 Cookie/Session，与后端 allowCredentials=true 配合（如 edu.skillith.cn -> us-res.zwhopescnc.com）
  withCredentials: true
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const authStore = useAuthStore()
    // 避免把 "undefined"/"null" 这种脏 token 带出去
    if (authStore.token && authStore.token !== 'undefined' && authStore.token !== 'null') {
      config.headers.Authorization = `Bearer ${authStore.token}`
    }
    
    return config
  },
  error => {
    console.error('[Request] 请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    
    // 检查响应码：0 表示成功，其他表示错误
    if (res.code !== 0 && res.code !== 200) {
      console.warn('[Request] 业务错误:', {
        code: res.code,
        message: res.message,
        url: response.config?.url
      })
      // 格式化封禁时间，确保只显示到分钟
      let errorMessage = res.message || '请求失败'
      errorMessage = errorMessage.replace(
        /到期时间:\s*(\d{4}-\d{2}-\d{2})[T\s](\d{2}):(\d{2}):\d{2}(\.\d+)?/,
        '到期时间: $1 $2:$3'
      )
      // 不当言论类错误由业务用专用弹窗展示，此处不弹出 ElMessage
      const isSensitiveContentError = /不当|敏感/.test(errorMessage)
      if (!isSensitiveContentError) {
        ElMessage.error(errorMessage)
      }
      return Promise.reject(new Error(errorMessage))
    }
    
    return res.data
  },
  error => {
    console.error('[Request] 响应错误:', error)
    
    if (error.response) {
      const { status, statusText, data } = error.response
      console.error('[Request] HTTP 错误:', {
        status,
        statusText,
        url: error.config?.url,
        data
      })
      
      if (status === 401) {
        console.warn('[Request] 401 未授权，执行登出')
        const authStore = useAuthStore()
        authStore.logout()
        // 已在登录页时不重复提示，避免总是弹出
        const onLoginPage = router.currentRoute?.value?.path === '/login'
        if (!onLoginPage) {
          ElMessage.error('登录已过期，请重新登录')
        }
      } else if (!error.config?.skipDefaultErrorMsg) {
        let errorMessage = data?.message || '请求失败'
        // 格式化封禁时间，确保只显示到分钟
        errorMessage = errorMessage.replace(
          /到期时间:\s*(\d{4}-\d{2}-\d{2})[T\s](\d{2}):(\d{2}):\d{2}(\.\d+)?/,
          '到期时间: $1 $2:$3'
        )
        console.error('[Request] 显示错误消息:', errorMessage)
        ElMessage.error(errorMessage)
      }
    } else if (error.request) {
      console.error('[Request] 网络错误，未收到响应:', error.request)
      ElMessage.error('网络错误，请检查网络连接')
    } else {
      console.error('[Request] 请求配置错误:', error.message)
      ElMessage.error('请求配置错误')
    }
    
    return Promise.reject(error)
  }
)

export default request
